export default "__VITE_ASSET__VFe1FbHI__"